"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.function.name.js");

var _emitter = _interopRequireDefault(require("element-ui/lib/mixins/emitter"));

var __vue_render__ = function __vue_render__(h) {
  var _vm = this;

  var _h = _vm.$createElement;
  var _c = h;
  return _c('label', {
    staticClass: "el-radio",
    "class": [_vm.border && _vm.radioSize ? 'el-radio--' + _vm.radioSize : '', {
      'is-disabled': _vm.isDisabled
    }, {
      'is-focus': _vm.focus
    }, {
      'is-bordered': _vm.border
    }, {
      'is-checked': _vm.model === _vm.label
    }],
    attrs: {
      "role": "radio",
      "aria-checked": _vm.model === _vm.label,
      "aria-disabled": _vm.isDisabled,
      "tabindex": _vm.tabIndex
    },
    on: {
      "keydown": function keydown($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "space", 32, $event.key, " ")) {
          return null;
        }

        $event.stopPropagation();
        $event.preventDefault();
        _vm.model = _vm.isDisabled ? _vm.model : _vm.label;
      }
    }
  }, [_c('span', {
    staticClass: "el-radio__input",
    "class": {
      'is-disabled': _vm.isDisabled,
      'is-checked': _vm.model === _vm.label
    },
    attrs: {}
  }, [_c('span', {
    staticClass: "el-radio__inner",
    attrs: {}
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.model,
      expression: "model"
    }],
    staticClass: "el-radio__original",
    attrs: {
      "type": "radio",
      "aria-hidden": "true",
      "name": _vm.name,
      "disabled": _vm.isDisabled,
      "tabindex": "-1"
    },
    domProps: {
      "value": _vm.label,
      "checked": _vm._q(_vm.model, _vm.label)
    },
    on: {
      "focus": function focus($event) {
        _vm.focus = true;
      },
      "blur": function blur($event) {
        _vm.focus = false;
      },
      "change": [function ($event) {
        _vm.model = _vm.label;
      }, _vm.handleChange]
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "el-radio__label",
    attrs: {},
    on: {
      "keydown": function keydown($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._t("default", null, {}), _vm._v(" "), !_vm.$slots["default"] ? [_vm._v(_vm._s(_vm.label))] : _vm._e()], 2)]);
};

var __vue_staticRenderFns__ = [];
var _default = {
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__,
  name: 'ElRadio',
  mixins: [_emitter["default"]],
  inject: {
    elForm: {
      "default": ''
    },
    elFormItem: {
      "default": ''
    }
  },
  componentName: 'ElRadio',
  props: {
    value: {},
    label: {},
    disabled: Boolean,
    name: String,
    border: Boolean,
    size: String
  },
  data: function data() {
    return {
      focus: false
    };
  },
  computed: {
    isGroup: function isGroup() {
      var parent = this.$parent;

      while (parent) {
        if (parent.$options.componentName !== 'ElRadioGroup') {
          parent = parent.$parent;
        } else {
          this._radioGroup = parent;
          return true;
        }
      }

      return false;
    },
    model: {
      get: function get() {
        return this.isGroup ? this._radioGroup.value : this.value;
      },
      set: function set(val) {
        if (this.isGroup) {
          this.dispatch('ElRadioGroup', 'input', [val]);
        } else {
          this.$emit('input', val);
        }
      }
    },
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    radioSize: function radioSize() {
      var temRadioSize = this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
      return this.isGroup ? this._radioGroup.radioGroupSize || temRadioSize : temRadioSize;
    },
    isDisabled: function isDisabled() {
      return this.isGroup ? this._radioGroup.disabled || this.disabled || (this.elForm || {}).disabled : this.disabled || (this.elForm || {}).disabled;
    },
    tabIndex: function tabIndex() {
      return !this.isDisabled ? this.isGroup ? this.model === this.label ? 0 : -1 : 0 : -1;
    }
  },
  methods: {
    handleChange: function handleChange() {
      var _this = this;

      this.$nextTick(function () {
        _this.$emit('change', _this.model);

        _this.isGroup && _this.dispatch('ElRadioGroup', 'handleChange', _this.model);
      });
    }
  }
};
exports["default"] = _default;